import React from 'react';
import { Area, Text, useTheme } from '@ublend-npm/aulaui-core';

type Props = {
  sx?: Record<string, unknown>;
};

const SearchNoResults = ({ sx }: Props) => {
  const theme = useTheme();

  return (
    <Area
      transparent
      rounded
      role="status"
      aria-live="polite"
      sx={{ textAlign: 'center', ...sx }}
    >
      <Text kind="p1">No results found!</Text>
      <Text kind="p2" sx={{ color: theme.palette.text.secondary }}>
        Remember to check the spelling.
      </Text>
    </Area>
  );
};

export default SearchNoResults;
